export const IMAGE_TYPE_CATEGORIES = [
  { value: 'all', label: 'All categories' },
  { value: 'PDP', label: 'PDP' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Social', label: 'Social' },
  { value: 'Email', label: 'Email' },
  { value: 'Other', label: 'Other' },
  { value: '', label: 'Uncategorised' },
];

export const IMAGE_TYPE_CATEGORY_OPTIONS = IMAGE_TYPE_CATEGORIES.filter((c) => c.value !== 'all');

export const SYSTEM_IMAGE_TYPES = [
  {
    key: 'elevated_hero',
    name: 'Elevated Hero',
    width: 3000,
    height: 3000,
    category: 'PDP',
    description: 'Primary product hero shot with elevated styling.',
    isSystem: true,
  },
  {
    key: 'rtb_image',
    name: 'RTB Image',
    width: 3000,
    height: 3000,
    category: 'PDP',
    description: 'Reasons-to-believe — claims, badges, or proof points.',
    isSystem: true,
  },
  {
    key: 'mobile_hero_a',
    name: 'Mobile Hero A',
    width: 1080,
    height: 1920,
    category: 'PDP',
    description: 'Mobile-first vertical hero variant.',
    isSystem: true,
  },
  {
    key: 'cross_sell',
    name: 'Cross-sell',
    width: 1500,
    height: 1500,
    category: 'PDP',
    description: 'Companion / cross-sell products and variants.',
    isSystem: true,
  },
  {
    key: 'lifestyle',
    name: 'Lifestyle',
    width: 3000,
    height: 3000,
    category: 'PDP',
    description: 'Product in a real-life scene or environment.',
    isSystem: true,
  },
  {
    key: 'product_gallery',
    name: 'Product Gallery',
    width: 1500,
    height: 1500,
    category: 'PDP',
    description: 'Gallery shot of the product — used for PDP carousels and grids.',
    isSystem: true,
  },
  {
    key: 'feature_iconography',
    name: 'Feature & Iconography',
    width: 1500,
    height: 1500,
    category: 'PDP',
    description: 'Feature callouts paired with supporting icons / benefit badges.',
    isSystem: true,
  },
  {
    key: 'category_gallery',
    name: 'Category Gallery',
    width: 1500,
    height: 1500,
    category: 'PDP',
    description: 'Gallery of related products within the same category.',
    isSystem: true,
  },
  {
    key: 'then_now',
    name: 'Then / Now',
    width: 1500,
    height: 1500,
    category: 'PDP',
    description: 'Old vs new packshot composite — old in the background, new in the foreground.',
    isSystem: true,
  },
  {
    key: 'icon_set',
    name: 'Icon Set',
    width: 1500,
    height: 1500,
    category: 'PDP',
    description: 'Benefit badges / iconography set (e.g. Vegan, Sustainable, Long-lasting).',
    isSystem: true,
  },
];

export function formatImageTypeSize(width, height) {
  if (!width && !height) {
    return '';
  }
  const w = width ? String(width) : 'Any';
  const h = height ? String(height) : 'Any';
  return `${w}×${h}`;
}
